import { Link as LinkRouter, useRouter, LinkProps } from "easy-page-router/react";

export function LanguageSwitch() {
    const { path } = useRouter();
    const lang = useLang();

    const csLink = path[0] === "pl" ? "/" + path.slice(1).join("/") : "/" + path.join("/");
    const plLink = path[0] === "pl" ? "/" + path.join("/") : "/" + ["pl", ...path].join("/");

    return <div className="language dropdown">
        <div className={"flag " + lang} /> {lang === "cs" ? "Čeština" : "Polski"}
        <div className="dropdown-content">
            <LinkRouter to={csLink}><div className={"flag cs"} /> Čeština</LinkRouter>
            <LinkRouter to={plLink}><div className={"flag pl"} /> Polski</LinkRouter>
        </div>
    </div>
}

export function Link({ to, ...props }: LinkProps) {
    const lang = useLang();
    return <LinkRouter to={`${lang === "pl" ? "/pl" : ""}${to}`} {...props} />
}

export function useLang(): "cs" | "pl" {
    const { path } = useRouter();

    if (path[0] === "pl") {
        return "pl";
    } else {
        return "cs";
    }
}